import { createReducer, on } from '@ngrx/store';
import { setPrices } from './prices.actions';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';

const localStorageService = new LocalStorageService();

export interface State {
  quotePrices; // quotePrices; TODO: crear modelo de quotePrices
}

export const initialState = localStorageService.get('quotePrices') || {};

export const pricesReducer = createReducer(
  initialState,

  on(setPrices, (state, { prices }) => ({ ...prices }))
);
